export default "__VITE_ASSET__9f315249__"